import '../scss/app.scss';
import '../scss/vendors/swiper.css';

require('./app-bootstrap'); // Объявление многих переменных в window

/** banners * */
App.vue.setComponent(require('./components/Banners/TopMessageBanner').default);

/** header * */
App.vue.setComponent(require('./components/Header/Header.vue').default);
App.vue.setComponent(require('./components/Header/HeaderTop.vue').default);

/** footer * */
App.vue.setComponent(require('./components/Footer/Footer.vue').default);
